import { ReactElement, useMemo } from 'react'
import { SelectionItem } from '../../../domain/selectionItem'
import ListSelectionItem from '../ListSelectionItem/ListSelectionItem'
import { ArrowNavigationLeft, ArrowNavigationRight } from '../SliderUtils/ArrowNavigation'
import { createGtmProduct } from '../../utils/gtmHelpers'
import ListSelectionSwiper from './ListSelectionSwiper'
import clsx from 'clsx'

type ListSelectionProps = {
  items: SelectionItem[]
  name?: ReactElement<'h2' | 'h3' | 'h4' | 'h5' | 'h6'>
  parentClassName?: string
  centerInsufficientSlides?: boolean
  hideColorVariations?: boolean
  disableSwiperOfImages?: boolean
  isHome?: boolean
  listId?: string
  listName?: string
}

const ListSelection = ({
  items,
  name,
  parentClassName,
  centerInsufficientSlides,
  hideColorVariations = false,
  disableSwiperOfImages = false,
  isHome = false,
  listId = '',
  listName = '',
}: ListSelectionProps) => {
  const gtmItems = useMemo(() => {
    return items.map((product, i) => {
      return createGtmProduct(product, {
        listName,
        listId,
        position: i + 1,
      })
    })
  }, [items])

  if (items.length < 1) {
    return null
  }

  return (
    <section className='list-selection'>
      {name}
      <div className="list-selection-wrapper">
        <ListSelectionSwiper
          items={gtmItems}
          parentClassName={parentClassName}
          centerInsufficientSlides={centerInsufficientSlides}>
          {items.map((item, i) => (
            <div className='swiper-slide list-selection-swiper-slide' key={item.sku} data-index={i}>
              <ListSelectionItem
                item={item}
                isHome={isHome}
                listId={listId}
                listName={listName}
                className='list-selection'
                hideColorVariations={hideColorVariations}
                keepOnlyOneImage={disableSwiperOfImages}
                position={i + 1}
              />
            </div>
          ))}
        </ListSelectionSwiper>

        <div
          className={clsx('navigation-container', {
            hidden: items.length <= 2,
            'lg-hidden': items.length <= 4,
            'lg-flex': items.length > 4,
          })}>
          <div className='bloc-navigation bloc-navigation-left'>
            <ArrowNavigationLeft />
          </div>

          <div className='explorer-animation bullet'>
            <div className='explorer-animation-bullet' />
            <div className='explorer-animation-bullet' />
            <div className='explorer-animation-bullet' />
          </div>

          <div className='bloc-navigation bloc-navigation-right'>
            <ArrowNavigationRight />
          </div>
        </div>
      </div>
    </section>
  )
}

export default ListSelection
